/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_1_DescInputs */

const en_mk_publish_1_desc = /** @type {(inputs: Mk_Publish_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try your app in the browser and review the checklist before publishing.`)
};

const id_mk_publish_1_desc = /** @type {(inputs: Mk_Publish_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba aplikasi di browser dan tinjau daftar pemeriksaan sebelum menerbitkan.`)
};

/**
* | output |
* | --- |
* | "Try your app in the browser and review the checklist before publishing." |
*
* @param {Mk_Publish_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_1_desc = /** @type {((inputs?: Mk_Publish_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_1_desc(inputs)
	return en_mk_publish_1_desc(inputs)
});